module.exports = __webpack_public_path__ + "img/campina-grande.122c0afe.png";